import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { MEDIA_COMMUNITIES_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateMedia from './components/CreateMedia/CreateMedia';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentMedia from './interfaces/IMaterialityAssessmentMedia';

import styles from './scss/MaterialityAssessmentMedia.module.scss';

function MaterialityAssessmentMediaView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  media, onEditRecord, onLoadMore, hasMore, onDeleteItem, selectedItem,
  recordId, setMedia, currentId, setOpenModal, vcmName, vcmId, isViewOnly = false,
}: IMaterialityAssessmentMedia) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantMedia')}
            buttonTitle={t('materialityAssessment.addMedia')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyMediaDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {media.length > 0 && (
                  <ItemsTable
                    items={media}
                    headCells={MEDIA_COMMUNITIES_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={loading}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateMedia
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addMedia')}
        selectedItem={selectedItem}
        recordId={recordId}
        setMedia={setMedia}
        currentId={currentId}
        setOpenModal={setOpenModal}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentMediaView;
